import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../../config";
import StoryCard from "./StoryCard";
import LoadingScreen from "../../common/LoadingScreen";
import { authFetch } from "../../../utils/auth";
import "../../../assets/css/storytelling.css";

// Find maximum sequence where ALL mandatory tiles of that sequence AND all prior sequences have full familiarity
function getMaxCompletedSequence(tiles) {
    if (!tiles || tiles.length === 0) return -1;
    const sequences = Array.from(new Set(tiles.map(t => parseInt(t.sequence, 10)))).sort((a, b) => a - b);
    let maxSeq = -1;
    for (let seq of sequences) {
        const mandatoryTilesInSeq = tiles.filter(t => parseInt(t.sequence, 10) === seq && (t.mandatory || t.mandatory === "TRUE" || t.mandatory === 1 || t.mandatory === "1" || t.mandatory === true));
        // If there are no mandatory tiles, it's considered complete by default
        const allCompleted = mandatoryTilesInSeq.length === 0 || mandatoryTilesInSeq.every(t => t.completed === 1);
        if (allCompleted) {
            maxSeq = seq;
        } else {
            break; // Stop at first incomplete unit
        }
    }
    return maxSeq;
}

function StorytellingDash({ tiles, lang_id }) {
    const [stories, setStories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (lang_id === undefined || lang_id === null) return;
        setLoading(true);
        authFetch(`${API_BASE_URL}/api/stories?lang_id=${lang_id}`)
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    setError(true);
                    console.error(data.error);
                } else {
                    setStories(data.stories || []);
                }
            })
            .catch(err => {
                console.error(err);
                setError(true);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [lang_id]);

    const maxCompletedSeq = getMaxCompletedSequence(tiles);

    return (
        <div className="stories-dashboard-root">
            {loading && <LoadingScreen inline title="Loading stories..." size={40} />}
            {error && <p>Error loading stories. Please try again later.</p>}
            {!loading && !error && stories.length === 0 && (
                <p>No stories available for this language yet.</p>
            )}

            {!loading && !error && stories.length > 0 && (
                <div className="stories-grid">
                    {stories.map(story => {
                        const isLocked = maxCompletedSeq < story.min_sequence;
                        return (
                            <StoryCard
                                key={story.id}
                                story={story}
                                locked={isLocked}
                                lang_id={lang_id}
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
}

export default StorytellingDash;
